import React from "react";
import resumeFile from "../documents/resume.pdf";
const AboutUs = ({ classicHeader, darkTheme }) => {
  return (
    <section id="about" className={"section " + (darkTheme ? "bg-dark-1" : "")}>
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            About Me
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            Know Me More
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gy-5">
          {/* About me content start */}
          <div className="col-lg-7 col-xl-8 text-center text-lg-start">
            <h2
              className={
                "text-7 fw-600 mb-3 " + (darkTheme ? "text-white" : "")
              }
            >
              I'm <span className="text-primary">Jeffrey Jimenez,</span> Creative and Engineer
            </h2>
            <p className={darkTheme ? "text-white-50" : ""}>
            Meet Jeffrey Jimenez, a Colombian technology professional and creative engineer based in Cali. My journey has been shaped by a lifelong curiosity for technology, computer science, innovation, and the process of transforming ideas into practical solutions.

I thrive at the intersection of engineering, technology, creativity, and business. My experience combines software development, digital technologies, project management, and marketing, allowing me to approach challenges from both a technical and strategic perspective. I enjoy understanding how systems work, identifying opportunities for improvement, and building solutions that create measurable value for businesses and their customers.

Throughout my professional journey, I have worked on digital projects that connect technology with real-world business needs. I have experience developing web applications and digital products, working with technologies such as React, TypeScript, JavaScript, Node.js, MongoDB, and cloud platforms, while also collaborating on digital strategy, website development, content management, optimization, and project execution.

One of my strongest interests is building products and businesses from the ground up. I enjoy taking an idea from its initial concept through development, deployment, and continuous improvement. This combination of technical execution and business thinking has allowed me to develop a strong understanding of how technology can be used not only to solve problems, but also to create new opportunities for growth, efficiency, and innovation.

I am particularly interested in technology entrepreneurship, SaaS products, digital transformation, artificial intelligence, software development, and emerging technologies. I continuously explore new tools, frameworks, and ideas that can help me build better products and understand where technology is heading.

Beyond technology, creativity is an important part of who I am. I enjoy connecting ideas from different disciplines and finding ways to transform complex concepts into simple, useful, and engaging experiences. I believe some of the most interesting solutions emerge when engineering, creativity, and business strategy come together.


            </p>
            <p className={darkTheme ? "text-white-50" : ""}>
            I am a Colombian native, born in Cali, Colombia, and my experiences across South America, North America, and Europe have given me a broader international perspective. Traveling and interacting with people from different cultures has strengthened my curiosity and my ability to adapt to different environments and ways of thinking.

Language has also played an important role in my journey. My passion for English and cross-cultural communication has allowed me to connect with people from different countries and expand both my professional and personal perspective.

Outside of my professional life, I enjoy exploring new experiences, learning about different cultures and ideas, and staying active. I have a particular passion for tennis and pickleball, which bring a competitive and dynamic dimension to my life.

Ultimately, my goal is to continue growing at the intersection of technology, engineering, creativity, and business, while building products and experiences that have a meaningful real-world impact. I am driven by curiosity, continuous learning, and the belief that technology can be one of the most powerful tools for creating better businesses, products, and experiences.
            </p>
          </div>
          {/* About me content end */}
          {/* about me personal detials start */}
          <div className="col-lg-5 col-xl-4">
            <div className="ps-lg-4">
              <ul
                className={
                  "list-style-2 " +
                  (darkTheme ? "list-style-light text-light" : "")
                }
              >
                <li>
                  <span className="fw-600 me-2">Name:</span>Jeffrey Jimenez
                </li>
                <li>
                  <span className="fw-600 me-2">Email:</span>
                  <a href="mailto:jimenezjeffrey1994@gmail.com">jimenezjeffrey1994@gmail.com</a>
                </li>
                <li className="border-0">
                  <span className="fw-600 me-2">From:</span>Cali,
                  Colombia
                </li>
              </ul>
              {/*<a
                href={resumeFile}
                download
                className="btn btn-primary rounded-pill"
              >
                Download CV
              </a>*/}
              </div>
          </div>
          {/* about me personal details end */}
        </div>
        {/* projects rewards counting start */}
        {/*<div
          className={
            "brands-grid separator-border mt-5 " +
            (darkTheme ? "separator-border-light" : "")
          }
        >
          <div className="row">
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>10</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Years Experiance
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>250</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Happy Clients
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>650</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Projects Done
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>38</span>
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Get Awards
                </p>
              </div>
            </div>
          </div>
                </div>*/}
        {/* projects rewards counting end */}
      </div>
    </section>
  );
};

export default AboutUs;
